
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class PelletsHowItWorks extends Vue {
  @Prop({
    default: "Pelletspreise vergleichen: So einfach geht es",
  })
  sectionTitle!: string;

  @Prop({
    default:
      "Unser Pelletspreise-Vergleich zeigt Ihnen mit wenigen Klicks die günstigsten Anbieter in Ihrer Region. Geben Sie einfach Postleitzahl, gewünschte Menge und Produktart (lose Ware oder Sackware) ein – Sie erhalten die aktuellen Preise pro Tonne im direkten Vergleich.",
  })
  descriptionPrimary!: string;

  @Prop({
    default:
      "So sparen Sie beim Pellets kaufen bares Geld und finden schnell den passenden Lieferanten mit dem besten Preis-Leistungs-Verhältnis. Die Preise werden regelmäßig aktualisiert, damit Sie die aktuellen Marktpreise für Holzpellets jederzeit im Blick haben.",
  })
  descriptionSecondary!: string;

  benefits: string[] = [
    "Über 77.000 verifizierte Kundenbewertungen",
    "TÜV-zertifizierter Preisvergleich über 20 Jahre am Markt",
    "Pelletshändler aus Ihrer Region",
    "Keine versteckten Kosten",
  ];
}
